import React from "react";
import { useLang } from "../context/LanguageContext";
import { ArrowRight, Footprints } from "lucide-react";

const Hero = () => {
  const { t } = useLang();

  return (
    <section id="inicio" className="relative overflow-hidden pt-32 md:pt-40 pb-20 md:pb-28 grain">
      {/* colorful blobs */}
      <div className="blob bg-[#FFD500] w-[420px] h-[420px] -top-20 -left-20" />
      <div className="blob bg-[#1E5FBA] w-[520px] h-[520px] -top-40 right-[-180px]" />
      <div className="blob bg-[#E63946] w-[360px] h-[360px] bottom-[-120px] left-[20%]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-white border border-[#E2E8F0] px-5 py-2.5 mb-6 shadow-sm">
            <Footprints className="w-4 h-4 text-[#1E5FBA]" strokeWidth={2.5} />
            <span className="text-xs md:text-sm font-bold uppercase tracking-[0.18em] text-[#1D3557]">
              Centro Pedagógico Infantil{" "}
              <span className="font-fredoka normal-case tracking-tight text-lg md:text-xl align-middle ml-1">
                <span style={{ color: "#1E5FBA" }}>S</span>
                <span style={{ color: "#2E9E4E" }}>t</span>
                <span style={{ color: "#E63946" }}>e</span>
                <span style={{ color: "#FFD500" }}>p</span>
                <span style={{ color: "#1E5FBA" }}>s</span>
              </span>
            </span>
          </div>

          <h1 className="font-fredoka text-6xl md:text-7xl lg:text-8xl font-semibold leading-[0.95] tracking-tight text-[#1D3557]">
            {t.hero.title1}{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-[#1E5FBA]">{t.hero.title2}</span>
              <span className="absolute left-0 right-0 bottom-2 h-4 md:h-5 bg-[#FFD500]/60 rounded-full -z-0" aria-hidden />
            </span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-[#457B9D] max-w-xl leading-relaxed">
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contacto"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-2 rounded-full bg-[#1E5FBA] hover:bg-[#164A94] text-white px-8 py-4 text-base font-semibold shadow-[0_12px_30px_rgba(30,95,186,0.35)] hover:-translate-y-0.5 transition-all"
            >
              {t.hero.ctaPrimary}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} />
            </a>
            <a
              href="#programa"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center rounded-full bg-white hover:bg-[#FDFBF7] text-[#1D3557] border-2 border-[#1D3557]/10 px-8 py-4 text-base font-semibold hover:-translate-y-0.5 transition-all"
            >
              {t.hero.ctaSecondary}
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
            {[t.hero.stat1, t.hero.stat2, t.hero.stat3].map((stat, i) => (
              <div
                key={i}
                className="bg-white/70 backdrop-blur border border-[#E2E8F0] rounded-2xl px-5 py-4"
                data-testid={`hero-stat-${i}`}
              >
                <div className="font-fredoka text-sm text-[#1D3557] font-medium leading-snug">{stat}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full max-w-lg ml-auto">
            {/* Main image card */}
            <div className="absolute inset-0 rounded-[2.5rem] overflow-hidden shadow-[0_30px_60px_rgba(29,53,87,0.18)] border-8 border-white">
              <img
                src="/images/hero.jpeg"
                alt="Obra de teatro escolar en STEPS"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Floating accents */}
            <div className="absolute -top-6 -left-6 w-28 h-28 rounded-[2rem] bg-[#FFD500] animate-float-slow shadow-[0_12px_32px_rgba(255,213,0,0.4)] grid place-items-center">
              <span className="font-fredoka text-[#1D3557] font-bold text-3xl">A+</span>
            </div>
            <div className="absolute -bottom-6 -right-4 w-36 bg-white rounded-3xl p-4 animate-float-medium shadow-[0_20px_40px_rgba(29,53,87,0.12)] border border-[#E2E8F0]">
              <div className="text-[10px] uppercase tracking-widest text-[#E63946] font-bold">Bilingual</div>
              <div className="font-fredoka text-[#1D3557] text-lg font-semibold leading-tight mt-1">ES · EN</div>
            </div>
            <div className="absolute top-1/2 -right-8 w-16 h-16 rounded-full bg-[#E63946] animate-float-slow" style={{ animationDelay: "1.2s" }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
